var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('vue-good-table',{ref:"sensorMeasureData",attrs:{"id":"measuresTable","mode":"remote","totalRows":_vm.totalRecords,"columns":_vm.columns,"rows":_vm.rows,"search-options":{
        skipDiacritics: true,
        placeholder: 'Buscar en la tabla',
      },"pagination-options":{
        enabled: true,
        nextLabel: '',
        prevLabel: '',
        rowsPerPageLabel: 'Filas por pagina',
        ofLabel: 'de',
        pageLabel: 'pagina', // for 'pages' mode
        allLabel: 'Todas',
      },"sort-options":{
        enabled: true,
        initialSortBy: { field: 'raw_ts', type: 'desc' },
      },"isLoading":_vm.isLoading},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange,"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}}},[_c('template',{slot:"loadingContent"},[_c('table-loading')],1),_c('template',{slot:"emptystate"},[_c('table-empty-state')],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }